import { Box, Typography } from "@mui/material";

type FieldProps = {
  label?: string;
  value: string;
};
export default function Field({ label, value }: FieldProps) {
  return (
    <Box mb={2}>
      <Typography fontWeight={600} fontSize={25}>
        {label}
      </Typography>
      <Typography fontWeight={400} fontSize={25} color="text.secondary">
        {value}
      </Typography>
    </Box>
  );
}
